<template>
  <div id="app">
    <div class="pd container mx-auto">
      <Card />
    </div>
  </div>
</template>

<script>
import Card from '@/components/Card/CardContainer';
export default {
  name: 'App',
  components: {
    Card,
  },
}
</script>

<style>
*, *::before, *::after {
  box-sizing: border-box;
}

.mx-auto {
  margin-left: auto;
  margin-right: auto;
}

.container {
  width: 1200px;
}

.img-resp {
  max-width: 100%;
  height: auto;
  vertical-align: bottom;
}

.row {
  margin-left: -15px;
  margin-right: -15px;
}

body {
  font-size: 15px;
  font-family: Arial, Helvetica, "LiHei Pro", "Microsoft JhengHei", MingLiU, sans-serif;
}

.pd__ls {
  display: flex;
  list-style-type: none;
  padding-left: 0;
  flex-wrap: wrap;
}
</style>



// WEBPACK FOOTER //
// src/App.vue